import { Recruiter } from '.';
import { LocaleCode } from '../../helpers';

export enum Role {
  DISABLED = 'DISABLED',
  CLIENT = 'CLIENT',
  RECRUITER = 'RECRUITER',
  TEAM_ADMIN = 'TEAM_ADMIN',
  PORTAL_ADMIN = 'PORTAL_ADMIN',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
}

export interface RequestInfo {
  id: number;
  recruiterId: number;
  email: string;
  portalId: number;
  locale: LocaleCode;
  role: Role;
}

export interface SocialLinks {
  linkedin?: string;
  github?: string;
  website?: string;
}

export interface Messengers {
  telegram?: string;
}

export interface CreatePayload {
  email: string;
  firstName: string;
  lastName?: string;
  locale: LocaleCode;
  phone?: string;
  isSystemAdmin: boolean;
  socialLinks?: SocialLinks;
  messengers?: Messengers;
}

export interface UpdatePayload extends CreatePayload {
  id: number;
}

export interface Base {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  fullName: string;
  image: string | null;
}

export interface Details extends Base {
  phone: string | null;
  socialLinks: SocialLinks;
  messengers: Messengers;
  createdAt: string;
  updatedAt: string;
}

export interface LoggedDetails
  extends Recruiter.MyInfo, Recruiter.QuickSettings {}
